import { Button, Text } from '@here/components'
import { RotateCcw } from 'lucide-solid'
import { Grid } from 'styled-system/jsx'

export const Scan = (props: {
	onScan: () => void
	onReset: () => void
	isDisabled: boolean
	isLoading: boolean
}) => {
	return (
		<Grid
			gap={2}
			alignItems="center"
			gridTemplateColumns={{
				base: '1fr auto auto',
				mdDown: '1fr',
			}}
		>
			<Text>
				Zoom in as far as possible and center the crop area on the white box in the top
				right,
				<br />
				This is to ensure an accurate scan, after click Exctract to scan the details
			</Text>
			<Button
				colorPalette="tscGreen"
				variant="subtle"
				onClick={props.onReset}
				disabled={props.isDisabled}
			>
				<RotateCcw />
				Start again
			</Button>
			<Button
				loading={props.isLoading}
				colorPalette="tscGreen"
				onClick={props.onScan}
				disabled={props.isDisabled}
			>
				Extract HVF Details
			</Button>
		</Grid>
	)
}
